module.exports = __webpack_public_path__ + "static/media/unitomo_logo.15c86f8a.png";